import { TutorialConfig } from "../types/tutorial";

const ordersTutorial: TutorialConfig = {
  pageId: "orders",
  pageTitle: "Orders Management",
  steps: [
    {
      id: "orders-kpis",
      title: "Status KPIs",
      description:
        "Quickly see counts for Pending, In Progress, At Risk, and Delayed orders. Click a KPI to filter the table below.",
      targetSelector: '[data-tutorial-step="orders-kpis"]',
      position: "bottom",
    },
    {
      id: "orders-filters",
      title: "Search & Filters",
      description:
        "Use the search box, status filter, and risk filter to find the exact shipments you are looking for.",
      targetSelector: '[data-tutorial-step="orders-filters"]',
      position: "bottom",
    },
    {
      id: "orders-table",
      title: "Shipments Table",
      description:
        "Each row shows shipment details, risk score, weather risk, tariff impact, and assigned route. Click a row to open the Order Intelligence Panel with full details.",
      targetSelector: '[data-tutorial-step="orders-table"]',
      position: "top",
    },
  ],
};

export default ordersTutorial;
